<template>
  <div class="myCollect">myCollect</div>
</template>

<script>
export default {
  name: "MyCollect"
};
</script>

<style lang="less" scoped></style>
